export default "__VITE_ASSET__B0NkwCw5__"